import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import { Search } from 'semantic-ui-react';
import { search as quickSearch, clear } from './actions/quickSearchActions';
import { search as itemSearch } from './actions/itemSearchActions';
import { debounce } from 'lodash';
import formatQuickSearchResults from './selectors/quickSearchSelector';

class SearchInputComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {value: ''};
    }

    handleSearchChange = debounce((e, { value }) => {

        // Clear the results
        this.props.clear();

        if(value) {
            this.props.quickSearch(value);
        }

    }, 750);

    onResultSelect = (e, result) => {
        const {extended} = result.result;

        if(!extended) {
            return;
        }

        if(extended.key === 'more') {
            // Perform an item search, using the search text
            this.props.itemSearch({text: `"${this.props.searchText}"`});

            // Rest the value of the search input so it doesn't stic with 'x more...'
            this.setState({value: ''});

            // Navigate to the appropriate search sub page
            this.props.history.push(`/${extended.type}`);
        } else {
            this.props.history.push(`/${extended.type}/${extended.key}`);
        }
    };

    render() {
        const {loading, results, dropDownPosition='left', fluid=true} = this.props;

        return (
            <Search
                // {...this.props}
                aligned={dropDownPosition}
                category={true}
                minCharacters={3}
                loading={loading}
                results={results}
                onSearchChange={(e, d) => {
                    this.setState({'value': d.value});
                    this.handleSearchChange(e, d);
                }}
                onResultSelect={this.onResultSelect}
                input={{fluid: fluid}}
                value={this.state.value}
            />
        );
    };
}

SearchInputComponent.propType = {
    loading: PropTypes.bool,
    results: PropTypes.array,
    dropDownPosition: PropTypes.string,
    fluid: PropTypes.bool,
};

const mapStateToProps = state => ({
    results: formatQuickSearchResults(state),
    loading: state.search.isFetching,
    searchText: state.search.searchText,
});

const mapDispatchToProps = () => ({
    clear,
    quickSearch,
    itemSearch,
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps())(SearchInputComponent));


// WEBPACK FOOTER //
// ./src/search/SearchInputComponent.js